import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import React from 'react'

const CompanyAccountsSettingsPageLazy = React.lazy(
    () => import('bpm/pages/CompanyAccountsSettingsPage/AccountsPage')
)
const CompanyAccountSetupPageLazy = React.lazy(
    () => import('bpm/pages/CompanyAccountsSettingsPage/AccountSetupPage')
)

export const CompanyAccountSettingsPageRoutes: RouteDictionary = {
    '/': {
        redirect: '/home',
    },
    '/home': {
        name: 'Home',
        component: CompanyAccountsSettingsPageLazy,
        componentProps: {
            title: 'Settings Page',
        },
    },
    '/account-setup/:accountId?': {
        component: CompanyAccountSetupPageLazy,
    },
    '/account-setup': {
        name: 'Account Setup',
        children: {
            '/:accountId': {},
        },
    },
}
